import React from 'react';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';
import WpButton from 'Wpds/components/button/WpButton';

// Hooks
import { useSmac } from 'Shared/utils/hooks/use-smac';
import { useApp } from 'Shared/utils/hooks/use-app';

// Utils
import { handleLaunchExternalLink } from 'Shared/utils/external-link';

// Styles
import './FullRelationshipGuideInsights.scss';

type Props = {
  selfSurveyUserId: string;
  colleagueSurveyUserId?: string;
};

const getInspireInsightsUrlPath = (
  hasClassicAccess: boolean,
  selfSurveyUserId: string,
  colleagueSurveyUserId: string
) => {
  if (hasClassicAccess && colleagueSurveyUserId) {
    return `person/${colleagueSurveyUserId}/relationship`;
  } else if (selfSurveyUserId && colleagueSurveyUserId) {
    return `pi/inspire/client/relationship/${selfSurveyUserId}/${colleagueSurveyUserId}`;
  }
  return '';
};

const FullRelationshipGuideInsights = ({ selfSurveyUserId, colleagueSurveyUserId }: Props): JSX.Element => {
  const { hasClassicAccess } = useSmac();
  const { app } = useApp();
  const baseClassName = 'FullRelationshipGuideInsights';
  const inspireInsightsUrl = `${app.piAppUrl}/${getInspireInsightsUrlPath(
    hasClassicAccess,
    selfSurveyUserId,
    colleagueSurveyUserId
  )}`;
  return (
    <WpContainer>
      <WpContainerBody>
        <div className={baseClassName}>
          <WpIllustration
            className={`${baseClassName}__image`}
            src={Illustrations.two_people_standing_with_laptop_purple_bg}
          />
          <div className={`${baseClassName}__title_wrapper`}>
            <h6 className={`${baseClassName}__title`}>Get full relationship insights, including:</h6>
            <div className={`${baseClassName}__description`}>
              <ul className={`${baseClassName}__insights_list`}>
                <li>Strengths</li>
                <li>Potential caution areas</li>
                <li>Tips to work better together</li>
              </ul>
              <WpButton size="md" onClick={() => handleLaunchExternalLink({ href: inspireInsightsUrl })}>
                View in Inspire
              </WpButton>
            </div>
          </div>
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default FullRelationshipGuideInsights;
